export enum EstadoRespuestaEnum { ANSWERED, ANSWERING, FCM_NOT_EXISTING, FCM_OK, NOT_INTERESTED, OPENED, VIEWED }

const idEstadoRespuesta = new Map<EstadoRespuestaEnum, string>();
idEstadoRespuesta.set(EstadoRespuestaEnum.ANSWERED, "ANSWERED");
idEstadoRespuesta.set(EstadoRespuestaEnum.ANSWERING, "ANSWERING");
idEstadoRespuesta.set(EstadoRespuestaEnum.FCM_NOT_EXISTING, "FCM_NOT_EXISTING");
idEstadoRespuesta.set(EstadoRespuestaEnum.FCM_OK, "FCM_OK");
idEstadoRespuesta.set(EstadoRespuestaEnum.NOT_INTERESTED, "NOT_INTERESTED");
idEstadoRespuesta.set(EstadoRespuestaEnum.OPENED, "OPENED");
idEstadoRespuesta.set(EstadoRespuestaEnum.VIEWED, "VIEWED");

export const obtenerIdEstadoRespuesta: (estado: EstadoRespuestaEnum) =>
    string = estado => idEstadoRespuesta.get(estado) ?? "";
